import i18n from "../i18n.config";

export function getTimeValuesExtended(
  dateStart,
  dateEnd,
  period,
  isReferencePlan = false,
  isExist = false
) {
  const timeValues = [];
  const timeValuesIrrigation = [];
  const arrayIndex = timeValues.length;
  let counterPeriod = 1;

  switch (period) {
    case 2: // Label: Diario
    case "DIARIO": {
      let currentDay = dateStart.clone();
      const lastDay = dateEnd.clone();
      while (currentDay.isSameOrBefore(lastDay)) {
        // Ejemplo de nombre: "25/08/2025"
        const varName = currentDay.format("DD/MM/YYYY");
        if (isExist) {
          timeValues.push(varName);
        } else {
          if (!timeValues[arrayIndex]) {
            timeValues.push({ [varName]: 0 });
            timeValuesIrrigation.push({
              [varName]: {
                periods_dose: 0,
                periods_product_irrigation: 0,
              },
            });
          } else {
            timeValues[arrayIndex][varName] = 0;
            timeValuesIrrigation[arrayIndex][varName] = {
              periods_dose: 0,
              periods_product_irrigation: 0,
            };
          }
        }
        currentDay.add(1, "day");
      }
      break;
    }
    case 1: // Label: Semanal
    case "SEMANAL": {
      let monthName;
      let isFirstTime = true;
      let currentWeekStart = dateStart.clone().startOf("isoWeek");
      const lastWeekEnd = dateEnd.clone().endOf("isoWeek");
      while (currentWeekStart.isBefore(lastWeekEnd)) {
        const year = currentWeekStart.year();
        const weekNumber = currentWeekStart.isoWeek();
        if (isFirstTime) {
          monthName = dateStart.format("MMMM");
          isFirstTime = false;
        } else {
          monthName = currentWeekStart.format("MMMM");
        }
        let varName = "";
        if (isReferencePlan) {
          varName = `${counterPeriod}º ${i18n.t("weekFullName")} ${i18n.t(
            `monthFull.${monthName}`
          )}`;
          counterPeriod += 1;
        } else {
          varName = `${i18n.t("weekFirstLetter")}${weekNumber} ${year} ${i18n.t(
            `monthFull.${monthName}`
          )}`;
        }
        if (isExist) {
          timeValues.push(varName);
        } else {
          if (!timeValues[arrayIndex]) {
            timeValues.push({ [varName]: 0 });
            timeValuesIrrigation.push({
              [varName]: {
                periods_dose: 0,
                periods_product_irrigation: 0,
              },
            });
          } else {
            timeValues[arrayIndex][varName] = 0;
            timeValuesIrrigation[arrayIndex][varName] = {
              periods_dose: 0,
              periods_product_irrigation: 0,
            };
          }
        }
        currentWeekStart.add(1, "week");
      }
      break;
    }
    case 0: // Label: Mensual
    case "MENSUAL":
    default: {
      const currentStart = dateStart.clone();
      const currentEnd = dateEnd.clone();
      while (
        currentEnd > currentStart ||
        currentStart.format("M") === currentEnd.format("M")
      ) {
        const monthFull = i18n.t(`monthFull.${currentStart.format("MMMM")}`);
        const varName = `${monthFull.split(".")[0]} - ${currentStart.format(
          "yy"
        )}`;
        if (isExist) {
          timeValues.push(varName);
        } else {
          if (!timeValues[arrayIndex]) {
            timeValues.push({ [varName]: 0 });
            timeValuesIrrigation.push({
              [varName]: {
                periods_dose: 0,
                periods_product_irrigation: 0,
              },
            });
          } else {
            timeValues[arrayIndex][varName] = 0;
            timeValuesIrrigation[arrayIndex][varName] = {
              periods_dose: 0,
              periods_product_irrigation: 0,
            };
          }
        }
        currentStart.add(1, "month");
      }
      break;
    }
  }

  return { timeValues, timeValuesIrrigation };
}
